<app-modal [isOpen]="isEventOpen" (close)="closeEventModal()" className="max-w-[700px]">
    <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">

        <!-- Header - FIXED -->
        <div class="flex-shrink-0 px-4 pt-4 pb-3 sm:px-6 sm:pt-6 sm:pb-4 bg-white dark:bg-gray-900 border-b border-gray-200">
            <h4 class="text-lg sm:text-2xl font-semibold text-gray-800 dark:text-white/90 mb-3 sm:mb-4">
                {{ isEditEventMode ? 'Edit Event' : 'Add new Event' }}
            </h4>
            <div class="flex items-center">
                <button (click)="!isEditEventMode && (activeTab = 'other')"
                    class="relative flex items-center gap-2 pb-2 px-3 sm:px-6 text-sm sm:text-xl font-regular transition-colors duration-200"
                    [class.text-[#D31148]]="activeTab === 'other'"
                    [class.text-gray-400]="activeTab !== 'other'"
                    [class.opacity-40]="isEditEventMode && activeTab === 'eventBrite'"
                    [class.cursor-not-allowed]="isEditEventMode && activeTab === 'eventBrite'"
                    [disabled]="isEditEventMode && activeTab === 'eventBrite'">
                    <span>Other</span>
                    <span *ngIf="activeTab === 'other'"
                        class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
                </button>

                <button *ngIf="!isEditEventMode || activeTab === 'eventBrite'"
                    (click)="!isEditEventMode && (activeTab = 'eventBrite')"
                    class="relative flex items-center gap-2 pb-2 px-3 sm:px-6 text-sm sm:text-xl font-regular transition-colors duration-200"
                    [class.text-[#D31148]]="activeTab === 'eventBrite'"
                    [class.text-gray-400]="activeTab !== 'eventBrite'"
                    [class.cursor-default]="isEditEventMode">
                    <span>Event Brite</span>
                    <span *ngIf="activeTab === 'eventBrite'"
                        class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#D31148] rounded-full"></span>
                </button>
            </div>
        </div>

        <!-- Content - SCROLLABLE -->
        <ng-container *ngIf="activeTab === 'other'">
            <div class="flex-1 overflow-y-auto">
                <form class="flex flex-col h-full">
                    <div class="flex-1 px-4 py-4 sm:px-6 sm:py-5">
                        <div class="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-1">

                            <div id="event-field-eventTitle">
                                <app-lable>Event Title</app-lable>
                                <app-input-field type="text" [(ngModel)]="eventTitle" name="eventTitle"
                                    (ngModelChange)="clearEventFieldError('eventTitle')"
                                    placeholder="Please enter event title" />
                                <p *ngIf="eventFieldErrors.eventTitle" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.eventTitle }}</p>
                            </div>

                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 sm:gap-y-0">
                                <div id="event-field-startDateTime">
                                    <app-lable>Start Date & Time</app-lable>
                                    <div class="flex gap-2" style="height: 45px;">
                                        <mat-form-field appearance="outline" class="event-date-field flex-1 min-w-0">
                                            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate"
                                                (ngModelChange)="clearEventFieldError('startDateTime')" name="startDate"
                                                placeholder="Start date">
                                            <mat-datepicker-toggle matIconSuffix [for]="startPicker" />
                                            <mat-datepicker #startPicker />
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="event-date-field w-28 sm:w-32 flex-shrink-0">
                                            <input matInput [matTimepicker]="startTimePicker" [(ngModel)]="startTime"
                                                (ngModelChange)="clearEventFieldError('startDateTime')" name="startTime"
                                                placeholder="Time">
                                            <mat-timepicker-toggle matIconSuffix [for]="startTimePicker" />
                                            <mat-timepicker #startTimePicker />
                                        </mat-form-field>
                                    </div>
                                    <p *ngIf="eventFieldErrors.startDateTime" class="mt-1 text-sm text-red-500">{{
                                        eventFieldErrors.startDateTime }}</p>
                                </div>

                                <div id="event-field-endDateTime">
                                    <app-lable>End Date & Time</app-lable>
                                    <div class="flex gap-2" style="height: 45px;">
                                        <mat-form-field appearance="outline" class="event-date-field flex-1 min-w-0">
                                            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate"
                                                (ngModelChange)="clearEventFieldError('endDateTime')" name="endDate"
                                                placeholder="End date">
                                            <mat-datepicker-toggle matIconSuffix [for]="endPicker" />
                                            <mat-datepicker #endPicker />
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" class="event-date-field w-28 sm:w-32 flex-shrink-0">
                                            <input matInput [matTimepicker]="endTimePicker" [(ngModel)]="endTime"
                                                (ngModelChange)="clearEventFieldError('endDateTime')" name="endTime"
                                                placeholder="Time">
                                            <mat-timepicker-toggle matIconSuffix [for]="endTimePicker" />
                                            <mat-timepicker #endTimePicker />
                                        </mat-form-field>
                                    </div>
                                    <p *ngIf="eventFieldErrors.endDateTime" class="mt-1 text-sm text-red-500">{{
                                        eventFieldErrors.endDateTime }}</p>
                                </div>
                            </div>

                            <div id="event-field-genre">
                                <app-lable>Category</app-lable>
                                <app-search-select [options]="genreOptions" placeholder="Please select event category"
                                    searchPlaceholder="Search category…"
                                    [value]="selectedGenre"
                                    (valueChange)="handleSelectGenreChange($event); clearEventFieldError('genre')"
                                    className="dark:bg-dark-900">
                                </app-search-select>
                                <p *ngIf="eventFieldErrors.genre" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.genre }}</p>
                            </div>

                            <div id="event-field-location">
                                <app-lable>Location</app-lable>
                                <div class="relative">
                                    <app-input-field type="text" #locationInput [(ngModel)]="locationText"
                                        (ngModelChange)="clearEventFieldError('location')" name="locationText"
                                        placeholder="Please enter location" />
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                        <path
                                            d="M11.9999 13.4295C13.723 13.4295 15.1199 12.0326 15.1199 10.3095C15.1199 8.58633 13.723 7.18945 11.9999 7.18945C10.2768 7.18945 8.87988 8.58633 8.87988 10.3095C8.87988 12.0326 10.2768 13.4295 11.9999 13.4295Z"
                                            stroke="currentColor" stroke-width="1.5" />
                                        <path
                                            d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
                                            stroke="currentColor" stroke-width="1.5" />
                                    </svg>
                                </div>
                                <p *ngIf="eventFieldErrors.location" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.location }}</p>
                            </div>

                            <!-- Min & Max Price in same row -->
                            <div class="grid grid-cols-2 gap-x-3 sm:gap-x-6">
                                <div id="event-field-minPrice">
                                    <app-lable>Min Price</app-lable>
                                    <div class="relative">
                                        <app-input-field type="text" [(ngModel)]="minPrice" name="minPrice"
                                            (ngModelChange)="clearEventFieldError('minPrice')"
                                            placeholder="e.g. 12.78" />
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                            <path
                                                d="M6.50391 10.7474C6.50391 11.7149 7.24641 12.4949 8.16891 12.4949H10.0514C10.8539 12.4949 11.5064 11.8124 11.5064 10.9724C11.5064 10.0574 11.1089 9.73488 10.5164 9.52488L7.49391 8.47488C6.90141 8.26488 6.50391 7.94238 6.50391 7.02738C6.50391 6.18738 7.15641 5.50488 7.95891 5.50488H9.84141C10.7639 5.50488 11.5064 6.28488 11.5064 7.25238"
                                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M9 4.5V13.5" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <p *ngIf="eventFieldErrors.minPrice" class="mt-1 text-sm text-red-500">{{
                                        eventFieldErrors.minPrice }}</p>
                                </div>

                                <div id="event-field-maxPrice">
                                    <app-lable>Max Price</app-lable>
                                    <div class="relative">
                                        <app-input-field type="text" [(ngModel)]="maxPrice" name="maxPrice"
                                            (ngModelChange)="clearEventFieldError('maxPrice')"
                                            placeholder="e.g. 27.77" />
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                            <path
                                                d="M6.50391 10.7474C6.50391 11.7149 7.24641 12.4949 8.16891 12.4949H10.0514C10.8539 12.4949 11.5064 11.8124 11.5064 10.9724C11.5064 10.0574 11.1089 9.73488 10.5164 9.52488L7.49391 8.47488C6.90141 8.26488 6.50391 7.94238 6.50391 7.02738C6.50391 6.18738 7.15641 5.50488 7.95891 5.50488H9.84141C10.7639 5.50488 11.5064 6.28488 11.5064 7.25238"
                                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M9 4.5V13.5" stroke="currentColor" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
                                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <p *ngIf="eventFieldErrors.maxPrice" class="mt-1 text-sm text-red-500">{{
                                        eventFieldErrors.maxPrice }}</p>
                                </div>
                            </div>
                            <p class="-mt-2 text-xs text-gray-400">For free events, please enter 0 in both fields.</p>

                            <div id="event-field-bookingLink">
                                <app-lable>Booking site link</app-lable>
                                <div class="relative">
                                    <app-input-field type="text" [(ngModel)]="bookingLink" name="bookingLink"
                                        (ngModelChange)="clearEventFieldError('bookingLink')"
                                        placeholder="https://example.com or www.example.com" />
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.828 10.172a4 4 0 0 1 0 5.656l-2 2a4 4 0 1 1-5.656-5.656l1.172-1.172"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M10.172 13.828a4 4 0 0 1 0-5.656l2-2a4 4 0 1 1 5.656 5.656l-1.172 1.172"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p *ngIf="eventFieldErrors.bookingLink" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.bookingLink }}</p>
                            </div>

                            <!-- Description with rich text editor -->
                            <div id="event-field-description">
                                <app-lable>Description</app-lable>
                                <angular-editor class="event-editor" [(ngModel)]="htmlContent" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="clearEventFieldError('description')" [config]="config">
                                </angular-editor>
                                <p *ngIf="eventFieldErrors.description" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.description }}</p>

                                <!-- Open Graph preview of the first link in the description.
                                     Card only — the editor above is untouched. -->
                                <app-link-preview [text]="htmlContent" [isHtml]="true"></app-link-preview>
                            </div>

                            <!-- Tag People -->
                            <div data-event-tag-section>
                                <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                    (click)="toggleEventTagPeople()">
                                    <div class="flex items-center gap-3">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                            class="text-gray-500 flex-shrink-0">
                                            <path
                                                d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                                                fill="currentColor" opacity="0.7" />
                                        </svg>
                                        <div class="flex items-center gap-2">
                                            <span class="text-sm font-medium text-gray-700">Tag people</span>
                                            <span *ngIf="eventTaggedPeople.length > 0"
                                                class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                                eventTaggedPeople.length }}</span>
                                        </div>
                                    </div>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        class="text-gray-400 flex-shrink-0 transition-transform"
                                        [class.rotate-90]="showEventTagPeople">
                                        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>

                                <div *ngIf="showEventTagPeople" class="mt-2 space-y-2">
                                    <!-- Tagged pills -->
                                    <div *ngIf="eventTaggedPeople.length > 0" class="flex flex-wrap gap-2 px-1">
                                        <span *ngFor="let u of eventTaggedPeople"
                                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 pl-1 pr-2 py-1 text-xs font-medium text-gray-700">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                            <span *ngIf="!u.profileImage?.urlSmall"
                                                class="w-5 h-5 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] text-[9px] font-bold flex-shrink-0">{{
                                                u.displayName.charAt(0) }}</span>
                                            @{{ u.userName }}
                                            <button type="button" (click)="removeEventTag(u._id)"
                                                class="text-gray-400 hover:text-gray-600 leading-none font-bold">×</button>
                                        </span>
                                    </div>
                                    <!-- Search input -->
                                    <div class="relative px-1">
                                        <input type="text" [(ngModel)]="eventTagSearchInput" name="eventTagSearchInput"
                                            placeholder="Search anyone by name or username…"
                                            (input)="onEventTagSearchInput($any($event.target).value)"
                                            (focus)="eventTagInputFocused = true"
                                            (blur)="onEventTagInputBlur()"
                                            class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                                stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <!-- Search results -->
                                    <div *ngIf="eventTagInputFocused && eventTagSearchResults.length > 0"
                                        class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                        <button *ngFor="let u of eventTagSearchResults" type="button"
                                            (mousedown)="addEventTag(u)"
                                            class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                            <div class="relative flex-shrink-0">
                                                <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                    class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                                <div *ngIf="!u.profileImage?.urlSmall"
                                                    class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                    {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                            </div>
                                            <div class="flex-1 min-w-0">
                                                <div class="text-sm font-semibold text-gray-800 truncate">{{
                                                    u.displayName }}</div>
                                                <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                            </div>
                                            <span *ngIf="u.isFriend"
                                                class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                        </button>
                                    </div>
                                    <!-- Empty state -->
                                    <p *ngIf="eventTagInputFocused && eventTagSearchInput.length > 0 && eventTagSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">No users found for "{{
                                        eventTagSearchInput }}"</p>
                                </div>
                            </div>

                            <!-- Invite Collaborators -->
                            <div data-event-collab-section>
                                <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                    (click)="toggleEventCollaborators()">
                                    <div class="flex items-center gap-3">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                            class="text-gray-500 flex-shrink-0">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                                stroke-width="1.6" stroke-linecap="round" />
                                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.6" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                                stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                        </svg>
                                        <div class="flex items-center gap-2">
                                            <span class="text-sm font-medium text-gray-700">Invite Collaborators</span>
                                            <span *ngIf="eventCollaborators.length > 0"
                                                class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                                eventCollaborators.length }}</span>
                                        </div>
                                    </div>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        class="text-gray-400 flex-shrink-0 transition-transform"
                                        [class.rotate-90]="showEventCollaborators">
                                        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>

                                <div *ngIf="showEventCollaborators" class="mt-2 space-y-2">
                                    <p class="text-xs text-gray-400 px-1" *ngIf="!isEditEventMode">Invite people you follow to co-host this event. They'll get a notification to accept or decline.</p>
                                    <p class="text-xs text-gray-400 px-1" *ngIf="isEditEventMode">Tap × to remove a collaborator. Add new ones by searching below.</p>
                                    <!-- Collaborator pills with status badge -->
                                    <div *ngIf="eventCollaborators.length > 0" class="flex flex-wrap gap-2 px-1">
                                        <span *ngFor="let u of eventCollaborators"
                                            class="inline-flex items-center gap-1.5 rounded-full border pl-1 pr-2 py-1 text-xs font-medium"
                                            [class.bg-emerald-50]="u.collabStatus === 'ACCEPTED'"
                                            [class.border-emerald-200]="u.collabStatus === 'ACCEPTED'"
                                            [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                            [class.bg-amber-50]="u.collabStatus === 'PENDING'"
                                            [class.border-amber-200]="u.collabStatus === 'PENDING'"
                                            [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                            [class.bg-rose-50]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                            [class.border-rose-200]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                            [class.text-[#D31148]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                            <span *ngIf="!u.profileImage?.urlSmall"
                                                class="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold flex-shrink-0"
                                                [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                                [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                                [class.bg-[#FFD4E0]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                                {{ u.displayName.charAt(0) }}
                                            </span>
                                            <span>@{{ u.userName }}</span>
                                            <!-- Status badge (edit mode only) -->
                                            <span *ngIf="isEditEventMode && u.collabStatus"
                                                class="text-[9px] font-bold px-1 py-0.5 rounded-full leading-none"
                                                [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                                [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                                [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                                [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                                [class.bg-rose-100]="u.collabStatus === 'DECLINED'"
                                                [class.text-rose-600]="u.collabStatus === 'DECLINED'">
                                                {{ u.collabStatus === 'ACCEPTED' ? '✓ Accepted' : u.collabStatus === 'PENDING' ? '⏳ Pending' : '✗ Declined' }}
                                            </span>
                                            <button type="button" (click)="removeEventCollaborator(u._id)"
                                                class="leading-none font-bold ml-0.5 hover:opacity-70"
                                                [class.text-emerald-500]="u.collabStatus === 'ACCEPTED'"
                                                [class.text-amber-500]="u.collabStatus === 'PENDING'"
                                                [class.text-rose-400]="!u.collabStatus || u.collabStatus === 'DECLINED'">×</button>
                                        </span>
                                    </div>
                                    <!-- Search input -->
                                    <div class="relative px-1">
                                        <input type="text" [(ngModel)]="eventCollabSearchInput"
                                            name="eventCollabSearchInput" placeholder="Search your friends…"
                                            (input)="onEventCollabSearchInput($any($event.target).value)"
                                            (focus)="eventCollabInputFocused = true"
                                            (blur)="onEventCollabInputBlur()"
                                            class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                                stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <!-- Collaborator results -->
                                    <div *ngIf="eventCollabInputFocused && eventCollabSearchResults.length > 0"
                                        class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                        <button *ngFor="let u of eventCollabSearchResults" type="button"
                                            (mousedown)="addEventCollaborator(u)"
                                            class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                            <div class="relative flex-shrink-0">
                                                <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                    class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                                <div *ngIf="!u.profileImage?.urlSmall"
                                                    class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                    {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                            </div>
                                            <div class="flex-1 min-w-0">
                                                <div class="text-sm font-semibold text-gray-800 truncate">{{
                                                    u.displayName }}</div>
                                                <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                            </div>
                                            <span *ngIf="u.isFriend"
                                                class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                        </button>
                                    </div>
                                    <!-- No results -->
                                    <p *ngIf="eventCollabInputFocused && eventCollabSearchInput.length > 0 && eventCollabSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">No results. You can only
                                        invite people you follow.</p>
                                    <!-- Empty initial state -->
                                    <p *ngIf="eventCollabInputFocused && eventCollabSearchInput.length === 0 && eventCollabSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">You don't follow anyone
                                        yet, or everyone is already invited.</p>
                                </div>
                            </div>

                            <!-- Event Images -->
                            <div id="event-field-images">
                                <app-lable>Event Images</app-lable>

                                <!-- Add-more buttons row -->
                                <div *ngIf="eventSelectedMedia.length > 0" class="mt-3 flex flex-wrap gap-1.5">
                                            <button type="button" (click)="fileInput.click()"
                                        class="w-40 h-14 rounded-xl border-2 border-dashed border-gray-300 hover:border-rose-400 bg-gray-50 hover:bg-rose-50 flex items-center justify-center gap-2 transition-all duration-200 group px-2">
                                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                                                    <path d="M8 3v10M3 8h10" stroke="#9CA3AF" stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        class="group-hover:stroke-rose-500 transition-colors duration-200" />
                                                </svg>
                                                <span class="text-xs text-gray-400 group-hover:text-rose-500 transition-colors font-medium">Add files</span>
                                            </button>
                                            <button type="button" (click)="openCameraForEvent()"
                                        class="w-40 h-14 rounded-xl border-2 border-dashed border-gray-300 hover:border-rose-400 bg-gray-50 hover:bg-rose-50 flex items-center justify-center gap-2 transition-all duration-200 group px-2">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                                    class="text-gray-400 group-hover:text-rose-500 transition-colors">
                                                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" />
                                                </svg>
                                                <span class="text-xs text-gray-400 group-hover:text-rose-500 transition-colors font-medium">Capture</span>
                                            </button>
                                        </div>

                                <!-- UNIFIED GRID: shown whenever there is any media (existing or new) -->
                                <div *ngIf="eventSelectedMedia.length > 0" class="mt-3 mb-2">
                                    <div class="grid grid-cols-2 sm:grid-cols-3 gap-3"
                                        cdkDropList
                                        (cdkDropListDropped)="onEventMediaDrop($event)">

                                        <!-- Unified, drag-to-reorder thumbnails (existing + new, in save order) -->
                                        <div *ngFor="let m of eventSelectedMedia; let i = index" cdkDrag
                                            class="relative aspect-[4/3] rounded-xl overflow-hidden group shadow-sm border-2 cursor-grab active:cursor-grabbing"
                                            [class.border-blue-200]="!!m.savedId"
                                            [class.border-gray-200]="!m.savedId">
                                            <img *ngIf="m.url" [src]="m.url"
                                                class="w-full h-full object-cover pointer-events-none"
                                                [class.opacity-50]="!m.isPreviewReady" />
                                            <div *ngIf="!m.url" class="absolute inset-0 bg-gray-100 animate-pulse"></div>
                                            <div class="absolute top-1.5 left-1.5 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-none"
                                                [class.bg-blue-500]="!!m.savedId" [class.bg-emerald-500]="!m.savedId">
                                                {{ m.savedId ? 'Saved' : 'New' }}
                                            </div>
                                            <div class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                                            <div *ngIf="!m.isPreviewReady"
                                                class="absolute inset-x-3 bottom-3 rounded-xl bg-white/92 px-3 py-2 shadow-lg backdrop-blur-sm">
                                                <div class="flex items-center justify-between gap-2">
                                                    <span class="text-[11px] font-semibold text-gray-700">Preparing</span>
                                                    <span class="text-[11px] font-semibold text-[#D31148]">{{ m.previewProgress }}%</span>
                                                </div>
                                                <div class="mt-1.5 h-1.5 overflow-hidden rounded-full bg-gray-200">
                                                    <div class="h-full rounded-full bg-[#D31148] transition-all duration-200" [style.width.%]="m.previewProgress"></div>
                                                </div>
                                            </div>
                                            <button type="button" (click)="$event.stopPropagation(); removeEventMedia(i)"
                                                class="absolute top-1.5 right-1.5 flex items-center justify-center w-6 h-6 bg-white/90 hover:bg-white rounded-full shadow-md transition-all duration-200 hover:scale-110">
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <path d="M1 1L9 9M9 1L1 9" stroke="#374151" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </button>
                                            <div *ngIf="m.file" class="absolute bottom-0 left-0 right-0 bg-black/50 px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                                <p class="text-white text-[10px] truncate">{{ m.file.name }}</p>
                                            </div>
                                        </div>

                                    </div>

                                    <p class="text-xs text-gray-400 mt-1">
                                        {{ eventSelectedMedia.length }} image{{ eventSelectedMedia.length !== 1 ? 's' : '' }} total &middot; drag to reorder
                                        <span *ngIf="eventSavedMediaCount > 0 && eventNewMediaCount > 0">
                                            ({{ eventNewMediaCount }} new)
                                        </span>
                                    </p>

                                    <div *ngIf="hasPendingEventPreviews" class="mt-2 rounded-xl bg-amber-50 px-3 py-2">
                                        <div class="flex items-center justify-between gap-3">
                                            <p class="text-xs font-medium text-amber-800">Preparing image previews for larger files</p>
                                            <span class="text-xs font-semibold text-amber-900">{{ eventPreviewProgress }}%</span>
                                        </div>
                                        <div class="mt-2 h-1.5 overflow-hidden rounded-full bg-amber-200">
                                            <div class="h-full rounded-full bg-amber-500 transition-all duration-200" [style.width.%]="eventPreviewProgress"></div>
                                        </div>
                                    </div>

                                    <div class="mt-2 rounded-xl border-2 border-dashed border-transparent hover:border-gray-200 p-2 transition-colors"
                                        [class.border-rose-400]="isDragging" [class.bg-rose-50]="isDragging"
                                        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                        (drop)="onDrop($event)">
                                        <p class="text-xs text-gray-400 text-center">Drop more images here</p>
                                    </div>
                                </div>

                                <!-- EMPTY STATE: no media at all -->
                                <div *ngIf="eventSelectedMedia.length === 0"
                                    class="mt-3 flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-gray-300 bg-gray-50 p-10 text-center transition-colors"
                                    [class.border-rose-500]="isDragging" [class.bg-rose-50]="isDragging"
                                    (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                    (drop)="onDrop($event)">
                                    <div class="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
                                        <svg class="h-7 w-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p class="text-sm font-medium text-gray-700">Select files or drag and drop here</p>
                                        <p class="mt-1 text-xs text-gray-400">JPG, PNG, JPEG, HEIC — up to 20MB each</p>
                                    </div>
                                    <div class="grid grid-cols-1 gap-3 mt-1 min-[500px]:flex min-[500px]:items-center">
                                        <button type="button" (click)="fileInput.click()"
                                            style="display: flex; justify-content: center;"
                                            class="flex items-center gap-2 rounded-lg bg-rose-600 px-5 py-2 text-sm font-semibold uppercase tracking-wider text-white transition hover:bg-rose-700 active:scale-95">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                <path d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Select Files
                                        </button>
                                        <button type="button" (click)="openCameraForEvent()"
                                            class="flex items-center gap-2 rounded-lg border-2 border-rose-600 text-rose-600 px-5 py-2 text-sm font-semibold uppercase tracking-wider bg-white hover:bg-rose-50 active:scale-95 transition">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" />
                                            </svg>
                                            Capture Photo
                                        </button>
                                    </div>
                                </div>

                                <input #fileInput type="file" accept="image/jpg,image/jpeg,image/png,image/webp,.jfif,image/heic,image/heif,.heic,.heif" multiple
                                    class="hidden" (change)="onFileSelected($event)" />
                                <p *ngIf="fileError" class="mt-2 text-sm text-red-500">{{ fileError }}</p>
                                <p *ngIf="eventFieldErrors.images" class="mt-2 text-sm text-red-500">{{ eventFieldErrors.images }}</p>
                            </div>
                            <!-- Hashtags -->
                            <div>
                                <app-lable>Hashtags</app-lable>
                                <div *ngIf="hashtags.length > 0" class="flex flex-wrap gap-2 mb-2 mt-1">
                                    <span *ngFor="let tag of hashtags"
                                        class="inline-flex items-center gap-1.5 rounded-full bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white">
                                        #{{ tag }}
                                        <button type="button" (click)="removeHashtag(tag)"
                                            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">
                                            ×
                                        </button>
                                    </span>
                                </div>
                                <div class="relative">
                                    <input type="text" appHashtagInput #hashDir="appHashtagInput"
                                        [(ngModel)]="hashtagInput" name="hashtagInput"
                                        (hashtagSearch)="onHashSearch($event)"
                                        (hashtagDropdown)="hashDropOpen = $event"
                                        (keydown.enter)="addHashtag($event)" (keydown.space)="addHashtag($event)" (separatorTyped)="addHashtag($event)"
                                        (keydown.comma)="addHashtag($event)"
                                        placeholder="Type a hashtag and press Enter (e.g. london)"
                                        class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm text-gray-700 outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                    <span
                                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path
                                                d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
                                            <line x1="7" y1="7" x2="7.01" y2="7" />
                                        </svg>
                                    </span>
                                    <app-hashtag-dropdown
                                        [isOpen]="hashDropOpen"
                                        [tags]="hashSuggestions"
                                        position="below"
                                        (selected)="onHashSelected($event)">
                                    </app-hashtag-dropdown>
                                </div>
                                <p class="mt-1 text-xs text-gray-400">Press Enter, Space - or pick a suggestion</p>
                            </div>

                        </div>
                    </div>
                </form>
            </div>

            <!-- Footer - STICKY -->
            <div class="flex-shrink-0 px-4 py-3 sm:px-6 sm:py-4 border-t border-gray-200 bg-white dark:bg-gray-900">
                <p *ngIf="saveError" class="text-sm text-red-500 mb-2">{{ saveError }}</p>
                <p *ngIf="saveSuccess" class="text-sm text-green-600 mb-2">{{ saveSuccess }}</p>
                <div *ngIf="isSaving && activeTab === 'other'" class="mb-3 rounded-xl bg-rose-50 px-3 py-2">
                    <div class="flex items-center justify-between gap-3">
                        <p class="text-xs font-medium text-rose-900">Uploading event images</p>
                        <span class="text-xs font-semibold text-[#D31148]">{{ eventUploadProgress }}%</span>
                    </div>
                    <div class="mt-2 h-1.5 overflow-hidden rounded-full bg-rose-100">
                        <div class="h-full rounded-full bg-[#D31148] transition-all duration-200"
                            [style.width.%]="eventUploadProgress"></div>
                    </div>
                </div>
                <div class="flex items-center gap-3 justify-end">
                    <app-button size="sm" variant="outline" (btnClick)="closeEventModal()"
                        [disabled]="isSaving">Close</app-button>
                    <app-button size="sm" (btnClick)="isEditEventMode ? saveEditEvent() : handleSave()"
                        [disabled]="isSaving || (activeTab === 'other' && hasPendingEventPreviews)">
                        {{ isSaving ? 'Saving...' : (isEditEventMode ? 'Save Changes' : 'Add Event') }}
                    </app-button>
                </div>
            </div>
        </ng-container>

        <!-- EventBrite Tab -->
        <ng-container *ngIf="activeTab === 'eventBrite'">
            <div class="flex-1 overflow-y-auto">
                <form class="flex flex-col h-full">
                    <div class="flex-1 px-4 py-4 sm:px-6 sm:py-5">
                        <div class="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-1">

                            <div id="event-field-eventbriteLink">
                                <app-lable>External link to Eventbrite event</app-lable>
                                <app-input-field type="text" [(ngModel)]="eventbriteLink" name="eventbriteLink"
                                    (ngModelChange)="clearEventFieldError('eventbriteLink')"
                                    placeholder="https://eventte.co.uk/e/exampletitle-tickets-553865e88247" />
                                <p *ngIf="eventFieldErrors.eventbriteLink" class="mt-1 text-sm text-red-500">{{
                                    eventFieldErrors.eventbriteLink }}</p>
                            </div>

                            <!-- Hashtags -->
                            <div>
                                <app-lable>Hashtags</app-lable>
                                <div *ngIf="ebHashtags.length > 0" class="flex flex-wrap gap-2 mb-2 mt-1">
                                    <span *ngFor="let tag of ebHashtags"
                                        class="inline-flex items-center gap-1.5 rounded-full bg-[#D31148] px-3 py-1.5 text-xs font-semibold text-white">
                                        #{{ tag }}
                                        <button type="button" (click)="removeEbHashtag(tag)"
                                            class="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none hover:bg-white/90 transition-colors">
                                            ×
                                        </button>
                                    </span>
                                </div>
                                <div class="relative">
                                    <input type="text" appHashtagInput #ebHashDir="appHashtagInput"
                                        [(ngModel)]="ebHashtagInput" name="ebHashtagInput"
                                        (hashtagSearch)="onEbHashSearch($event)"
                                        (hashtagDropdown)="ebHashDropOpen = $event"
                                        (keydown.enter)="addEbHashtag($event)" (keydown.space)="addEbHashtag($event)" (separatorTyped)="addEbHashtag($event)"
                                        (keydown.comma)="addEbHashtag($event)"
                                        placeholder="Type a hashtag and press Enter (e.g. london)"
                                        class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 pr-10 text-sm text-gray-700 outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                    <span
                                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path
                                                d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
                                            <line x1="7" y1="7" x2="7.01" y2="7" />
                                        </svg>
                                    </span>
                                    <app-hashtag-dropdown
                                        [isOpen]="ebHashDropOpen"
                                        [tags]="ebHashSuggestions"
                                        position="below"
                                        (selected)="onEbHashSelected($event)">
                                    </app-hashtag-dropdown>
                                </div>
                                <p class="mt-1 text-xs text-gray-400">Press Enter, Space - or pick a suggestion</p>
                            </div>

                            <!-- Tag People (EB) -->
                            <div data-eb-tag-section>
                                <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                    (click)="toggleEbTagPeople()">
                                    <div class="flex items-center gap-3">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                            class="text-gray-500 flex-shrink-0">
                                            <path
                                                d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                                                fill="currentColor" opacity="0.7" />
                                        </svg>
                                        <div class="flex items-center gap-2">
                                            <span class="text-sm font-medium text-gray-700">Tag people</span>
                                            <span *ngIf="ebTaggedPeople.length > 0"
                                                class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                                ebTaggedPeople.length }}</span>
                                        </div>
                                    </div>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        class="text-gray-400 flex-shrink-0 transition-transform"
                                        [class.rotate-90]="showEbTagPeople">
                                        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div *ngIf="showEbTagPeople" class="mt-2 space-y-2">
                                    <div *ngIf="ebTaggedPeople.length > 0" class="flex flex-wrap gap-2 px-1">
                                        <span *ngFor="let u of ebTaggedPeople"
                                            class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 pl-1 pr-2 py-1 text-xs font-medium text-gray-700">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                            <span *ngIf="!u.profileImage?.urlSmall"
                                                class="w-5 h-5 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] text-[9px] font-bold flex-shrink-0">{{
                                                u.displayName.charAt(0) }}</span>
                                            @{{ u.userName }}
                                            <button type="button" (click)="removeEbTag(u._id)"
                                                class="text-gray-400 hover:text-gray-600 leading-none font-bold">×</button>
                                        </span>
                                    </div>
                                    <div class="relative px-1">
                                        <input type="text" [(ngModel)]="ebTagSearchInput" name="ebTagSearchInput"
                                            placeholder="Search anyone by name or username..."
                                            (input)="onEbTagSearchInput($any($event.target).value)"
                                            (focus)="ebTagInputFocused = true"
                                            (blur)="onEbTagInputBlur()"
                                            class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                                stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <div *ngIf="ebTagInputFocused && ebTagSearchResults.length > 0"
                                        class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                        <button *ngFor="let u of ebTagSearchResults" type="button"
                                            (mousedown)="addEbTag(u)"
                                            class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                            <div class="relative flex-shrink-0">
                                                <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                    class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                                <div *ngIf="!u.profileImage?.urlSmall"
                                                    class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                    {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                            </div>
                                            <div class="flex-1 min-w-0">
                                                <div class="text-sm font-semibold text-gray-800 truncate">{{
                                                    u.displayName }}</div>
                                                <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                            </div>
                                            <span *ngIf="u.isFriend"
                                                class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                        </button>
                                    </div>
                                    <p *ngIf="ebTagInputFocused && ebTagSearchInput.length > 0 && ebTagSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">No users found for "{{
                                        ebTagSearchInput }}"</p>
                                </div>
                            </div>

                            <!-- Invite Collaborators (EB) -->
                            <div data-eb-collab-section>
                                <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                    (click)="toggleEbCollaborators()">
                                    <div class="flex items-center gap-3">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                            class="text-gray-500 flex-shrink-0">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                                stroke-width="1.6" stroke-linecap="round" />
                                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.6" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                                stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                        </svg>
                                        <div class="flex items-center gap-2">
                                            <span class="text-sm font-medium text-gray-700">Invite Collaborators</span>
                                            <span *ngIf="ebCollaborators.length > 0"
                                                class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                                ebCollaborators.length }}</span>
                                        </div>
                                    </div>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        class="text-gray-400 flex-shrink-0 transition-transform"
                                        [class.rotate-90]="showEbCollaborators">
                                        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div *ngIf="showEbCollaborators" class="mt-2 space-y-2">
                                    <p class="text-xs text-gray-400 px-1">Invite people you follow to co-host this
                                        event. They'll get a notification to accept or decline.</p>
                                    <div *ngIf="ebCollaborators.length > 0" class="flex flex-wrap gap-2 px-1">
                                        <span *ngFor="let u of ebCollaborators"
                                            class="inline-flex items-center gap-1.5 rounded-full border pl-1 pr-2 py-1 text-xs font-medium"
                                            [class.bg-emerald-50]="u.collabStatus === 'ACCEPTED'"
                                            [class.border-emerald-200]="u.collabStatus === 'ACCEPTED'"
                                            [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                            [class.bg-amber-50]="u.collabStatus === 'PENDING'"
                                            [class.border-amber-200]="u.collabStatus === 'PENDING'"
                                            [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                            [class.bg-rose-50]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                            [class.border-rose-200]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                            [class.text-[#D31148]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                            <span *ngIf="!u.profileImage?.urlSmall"
                                                class="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold flex-shrink-0"
                                                [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                                [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                                [class.bg-[#FFD4E0]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                                {{ u.displayName.charAt(0) }}
                                            </span>
                                            <span>@{{ u.userName }}</span>
                                            <span *ngIf="isEditEventMode && u.collabStatus"
                                                class="text-[9px] font-bold px-1 py-0.5 rounded-full leading-none"
                                                [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                                [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                                [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                                [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                                [class.bg-rose-100]="u.collabStatus === 'DECLINED'"
                                                [class.text-rose-600]="u.collabStatus === 'DECLINED'">
                                                {{ u.collabStatus === 'ACCEPTED' ? '✓ Accepted' : u.collabStatus === 'PENDING' ? '⏳ Pending' : '✗ Declined' }}
                                            </span>
                                            <button type="button" (click)="removeEbCollaborator(u._id)"
                                                class="leading-none font-bold ml-0.5 hover:opacity-70"
                                                [class.text-emerald-500]="u.collabStatus === 'ACCEPTED'"
                                                [class.text-amber-500]="u.collabStatus === 'PENDING'"
                                                [class.text-rose-400]="!u.collabStatus || u.collabStatus === 'DECLINED'">×</button>
                                        </span>
                                    </div>
                                    <div class="relative px-1">
                                        <input type="text" [(ngModel)]="ebCollabSearchInput" name="ebCollabSearchInput"
                                            placeholder="Search your friends..."
                                            (input)="onEbCollabSearchInput($any($event.target).value)"
                                            (focus)="ebCollabInputFocused = true"
                                            (blur)="onEbCollabInputBlur()"
                                            class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                            <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                                stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <div *ngIf="ebCollabInputFocused && ebCollabSearchResults.length > 0"
                                        class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                        <button *ngFor="let u of ebCollabSearchResults" type="button"
                                            (mousedown)="addEbCollaborator(u)"
                                            class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                            <div class="relative flex-shrink-0">
                                                <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                    class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                                <div *ngIf="!u.profileImage?.urlSmall"
                                                    class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                    {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                            </div>
                                            <div class="flex-1 min-w-0">
                                                <div class="text-sm font-semibold text-gray-800 truncate">{{
                                                    u.displayName }}</div>
                                                <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                            </div>
                                            <span *ngIf="u.isFriend"
                                                class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                        </button>
                                    </div>
                                    <p *ngIf="ebCollabInputFocused && ebCollabSearchInput.length > 0 && ebCollabSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">No results. You can only
                                        invite people you follow.</p>
                                    <p *ngIf="ebCollabInputFocused && ebCollabSearchInput.length === 0 && ebCollabSearchResults.length === 0"
                                        class="text-xs text-gray-400 px-1 text-center py-2">You don't follow anyone yet,
                                        or everyone is already invited.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>

            <!-- Footer - STICKY -->
            <div class="flex-shrink-0 px-4 py-3 sm:px-6 sm:py-4 border-t border-gray-200 bg-white dark:bg-gray-900">
                <p *ngIf="saveError" class="text-sm text-red-500 mb-2">{{ saveError }}</p>
                <p *ngIf="saveSuccess" class="text-sm text-green-600 mb-2">{{ saveSuccess }}</p>
                <div class="flex items-center gap-3 justify-end">
                    <app-button size="sm" variant="outline" (btnClick)="closeEventModal()">Close</app-button>
                    <app-button size="sm" (btnClick)="isEditEventMode ? saveEditEvent() : handleSave()" [disabled]="isSaving">
                        {{ isSaving ? 'Saving...' : (isEditEventMode ? 'Save Changes' : 'Add Event') }}
                    </app-button>
                </div>
            </div>
        </ng-container>

    </div>
</app-modal>

<app-modal #postModal [isOpen]="isPostOpen" (close)="closePostModal()" className="max-w-[600px]">
    <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">

        <!-- Modal Header - FIXED -->
        <div
            class="flex-shrink-0 flex items-center justify-between px-6 pt-6 pb-4 border-b border-gray-100 bg-white dark:bg-gray-900 z-10">
            <h4 class="text-xl font-semibold text-gray-800 dark:text-white/90">{{ isEditPostMode ? 'Edit post' : 'New post' }}</h4>
            <button (click)="closePostModal()"
                class="flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
            </button>
        </div>

        <!-- ════ STEP 1: Choose Media ════ -->
        <ng-container *ngIf="postStep === 1">
            <div class="flex-1 overflow-y-auto">
                <div class="px-6 py-5 space-y-5">

                    <!-- EDIT MODE: current media (unified list — saved + new) -->
                    <div *ngIf="isEditPostMode && postSelectedMedia.length > 0" class="space-y-2">
                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-widest">Current media</p>
                        <div class="flex gap-3 overflow-x-auto pb-1">
                            <div *ngFor="let m of postSelectedMedia; let i = index"
                                class="relative flex-shrink-0 w-28 h-24 rounded-xl overflow-hidden border-2 border-[#D31148] group">
                                <img *ngIf="m.type === 'image' && m.url" [src]="m.url" class="w-full h-full object-cover" />
                                <video *ngIf="m.type === 'video' && m.url" [src]="m.url" class="w-full h-full object-cover" muted playsinline></video>
                                <span *ngIf="m.type === 'video'" class="absolute bottom-1 left-1 bg-black/60 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">VIDEO</span>
                                <span *ngIf="m.savedId" class="absolute top-1 left-1 bg-[#D31148]/80 text-white text-[8px] font-bold px-1 py-0.5 rounded leading-none">Saved</span>
                                <span *ngIf="!m.savedId" class="absolute top-1 left-1 bg-blue-500/80 text-white text-[8px] font-bold px-1 py-0.5 rounded leading-none">New</span>
                                <!-- Always visible, not hover-revealed: there is no hover on a
                                     touch device, so gating it left phone users with no way to
                                     remove a file. -->
                                <button type="button" (click)="removePostMedia(i)" aria-label="Remove media"
                                    class="absolute top-1 right-1 w-6 h-6 bg-white/90 rounded-full flex items-center justify-center transition-colors shadow hover:bg-white">
                                    <svg width="8" height="8" viewBox="0 0 8 8">
                                        <path d="M1 1L7 7M7 1L1 7" stroke="#374151" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p class="text-xs text-gray-400">Tap × on a tile to remove it. Add new files below to add more.</p>
                    </div>

                    <div *ngIf="!selectedPostGradient && !isEditPostMode" class="space-y-1">
                        <div class="flex gap-3 overflow-x-auto pb-1" *ngIf="postSelectedMedia.length > 0">
                            <div *ngFor="let m of postSelectedMedia; let i = index"
                                class="relative flex-shrink-0 w-28 h-24 rounded-xl overflow-hidden border border-gray-200 group">
                                <img *ngIf="m.type === 'image' && m.url" [src]="m.url"
                                    class="w-full h-full object-cover" [class.opacity-50]="!m.isPreviewReady" />
                                <video *ngIf="m.type === 'video' && m.url" [src]="m.url"
                                    class="w-full h-full object-cover" muted playsinline></video>
                                <div *ngIf="!m.url" class="absolute inset-0 bg-gray-100 animate-pulse"></div>
                                <span *ngIf="m.type === 'video'"
                                    class="absolute bottom-1 left-1 bg-black/60 text-white text-[9px] font-bold px-1.5 py-0.5 rounded">VIDEO</span>
                                <div *ngIf="!m.isPreviewReady"
                                    class="absolute inset-x-2 bottom-2 rounded-lg bg-white/92 px-2 py-1.5 shadow-sm">
                                    <div class="flex items-center justify-between gap-2">
                                        <span class="text-[10px] font-semibold text-gray-700">Preparing</span>
                                        <span class="text-[10px] font-semibold text-[#D31148]">{{ m.previewProgress
                                            }}%</span>
                                    </div>
                                    <div class="mt-1 h-1 overflow-hidden rounded-full bg-gray-200">
                                        <div class="h-full rounded-full bg-[#D31148] transition-all duration-200"
                                            [style.width.%]="m.previewProgress"></div>
                                    </div>
                                </div>
                                <!-- Always visible — no hover on touch devices. -->
                                <button type="button" (click)="removePostMedia(i)" aria-label="Remove media"
                                    class="absolute top-1 right-1 w-6 h-6 bg-white/90 rounded-full flex items-center justify-center transition-colors shadow hover:bg-white">
                                    <svg width="8" height="8" viewBox="0 0 8 8">
                                        <path d="M1 1L7 7M7 1L1 7" stroke="#374151" stroke-width="1.5"
                                            stroke-linecap="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <p class="text-xs text-gray-400">{{ postSelectedMedia.length }} file{{ postSelectedMedia.length
                            !==
                            1 ? 's' : '' }} selected</p>
                        <div *ngIf="hasPendingPostPreviews" class="rounded-xl bg-amber-50 px-3 py-2">
                            <div class="flex items-center justify-between gap-3">
                                <p class="text-xs font-medium text-amber-800">Preparing media previews for larger
                                    uploads</p>
                                <span class="text-xs font-semibold text-amber-900">{{ postPreviewProgress }}%</span>
                            </div>
                            <div class="mt-2 h-1.5 overflow-hidden rounded-full bg-amber-200">
                                <div class="h-full rounded-full bg-amber-500 transition-all duration-200"
                                    [style.width.%]="postPreviewProgress"></div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Upload zone -->
                    <div *ngIf="!selectedPostGradient"
                        class="rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 px-6 py-3 flex flex-col items-center gap-3 text-center transition-colors"
                        [class.border-[#D31148]]="isPostDragging" [class.bg-rose-50]="isPostDragging"
                        (dragover)="onPostDragOver($event)" (dragleave)="onPostDragLeave($event)"
                        (drop)="onPostDrop($event)">
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" class="text-gray-400">
                            <path d="M22 34V22M22 22L16 28M22 22L28 28" stroke="currentColor" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8 30C5.24 28.74 3 25.9 3 22.5C3 17.81 6.81 14 11.5 14C11.83 14 12.16 14.02 12.48 14.06C13.98 10.48 17.67 8 22 8C27.52 8 32 12.48 32 18C32 18.29 31.99 18.58 31.97 18.87C35.34 19.48 38 22.44 38 26C38 29.31 35.73 32.07 32.67 32.77"
                                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <div>
                            <!-- <p class="text-sm font-medium text-gray-700">Select a file or drag and drop here</p> -->
                            <p class="mt-1 text-xs text-gray-400">JPG, PNG, WEBP, HEIC or MP4/WEBM — up to 20MB image / 50MB video
                            </p>
                        </div>

                        <!-- ── TWO BUTTONS SIDE BY SIDE ── -->
                        <div class="flex flex-col items-center gap-3 mt-1">

                            <!-- Upload photo / video — flex row on desktop, stacked on mobile -->
                            <div class="flex flex-col min-[500px]:flex-row items-center gap-3">

                                <!-- Upload photo -->
                                <button type="button" (click)="postFileInput.click()"
                                    class="flex w-[200px] items-center justify-center gap-2 rounded-lg border-2 border-transparent bg-[#D31148] px-5 py-2 text-sm font-semibold uppercase tracking-wider text-white transition hover:bg-[#b80e3d] active:scale-95">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="2" />
                                        <path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Upload Photo
                                </button>

                                <!-- Upload video -->
                                <button type="button" (click)="postVideoInput.click()"
                                    class="flex w-[200px] items-center justify-center gap-2 rounded-lg border-2 border-transparent bg-[#D31148] px-5 py-2 text-sm font-semibold uppercase tracking-wider text-white transition hover:bg-[#b80e3d] active:scale-95">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M23 7l-7 5 7 5V7z" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <rect x="1" y="5" width="15" height="14" rx="2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Upload Video
                                </button>

                            </div>

                            <!-- Capture buttons — flex row on desktop, stacked on mobile -->
                            <div class="flex flex-col min-[500px]:flex-row items-center gap-3">

                                <!-- Capture live image -->
                                <button type="button" (click)="openCameraForPost()"
                                    class="flex w-[200px] items-center justify-center gap-2 rounded-lg border-2 border-[#D31148] text-[#D31148] px-5 py-2 text-sm font-semibold uppercase tracking-wider bg-white hover:bg-rose-50 active:scale-95 transition">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" />
                                    </svg>
                                    Capture Photo
                                </button>

                                <!-- Capture live video -->
                                <button type="button" (click)="openVideoCaptureForPost()"
                                    class="flex w-[200px] items-center justify-center gap-2 rounded-lg border-2 border-[#D31148] text-[#D31148] px-5 py-2 text-sm font-semibold uppercase tracking-wider bg-white hover:bg-rose-50 active:scale-95 transition">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M23 7l-7 5 7 5V7z" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <rect x="1" y="5" width="15" height="14" rx="2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Capture Video
                                </button>

                            </div>
                        </div>

                        <input #postFileInput type="file" accept="image/jpg,image/jpeg,image/png,image/webp,.jfif,image/heic,image/heif,.heic,.heif"
                            multiple class="hidden" (change)="onPostFileSelected($event)" />
                        <!-- video/quicktime + .mov: iPhone library videos are QuickTime,
                             and without them iOS greys the whole library out. -->
                        <input #postVideoInput type="file"
                            accept="video/mp4,video/mpeg,video/webm,video/quicktime,.mp4,.mov,.webm"
                            multiple class="hidden" (change)="onPostFileSelected($event)" />
                    </div>
                    <p *ngIf="postFileError" class="text-sm text-red-500 -mt-2">{{ postFileError }}</p>

                    <!-- Media thumbnails -->
                    
                    <!-- Divider -->
                    <div *ngIf="!selectedPostGradient && postSelectedMedia.length === 0" class="flex items-center gap-3">
                        <div class="flex-1 h-px bg-gray-200"></div>
                        <span class="text-xs font-medium text-gray-400 uppercase tracking-widest">OR</span>
                        <div class="flex-1 h-px bg-gray-200"></div>
                    </div>

                    <!-- Pattern picker -->
                    <div *ngIf="postSelectedMedia.length === 0">
                        <p class="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-2">Choose a
                            background
                        </p>
                        <div class="flex overflow-x-auto gap-3 pb-1"
                            style="scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; scrollbar-width: none;">
                            <button *ngFor="let p of postPatterns" type="button" (click)="selectPostPattern(p)"
                                class="relative flex-shrink-0 overflow-hidden rounded-2xl transition-all duration-200 hover:scale-[1.03] focus:outline-none"
                                style="width: 140px; height: 90px; scroll-snap-align: start;"
                                [class.ring-2]="selectedPostGradient === p.id"
                                [class.ring-[#D31148]]="selectedPostGradient === p.id"
                                [class.ring-offset-2]="selectedPostGradient === p.id" [ngClass]="p.patternClass"
                                [style.background-color]="p.bg" [style.color]="p.color">
                                <span
                                    class="absolute bottom-1.5 left-0 right-0 text-center text-[10px] font-bold drop-shadow"
                                    [style.color]="p.textColor">{{ p.name }}</span>
                            </button>
                        </div>
                    </div>

                    <!-- Pattern preview (read-only on step 1) -->
                    <div *ngIf="selectedPostGradient && postSelectedMedia.length === 0"
                        class="relative rounded-2xl overflow-hidden w-full transition-all duration-300"
                        style="height: 180px;" [ngClass]="getSelectedPattern()?.patternClass"
                        [style.background-color]="getSelectedPattern()?.bg" [style.color]="getSelectedPattern()?.color">
                        <button type="button" (click)="clearPostPattern()" title="Remove background"
                            class="absolute top-2 right-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-black/40 text-white hover:bg-black/60 transition-colors">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" />
                            </svg>
                        </button>
                        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <p class="text-sm font-semibold opacity-60 px-4 text-center"
                                [style.color]="getSelectedPattern()?.textColor">
                                ✏️ You'll add your caption on the next screen
                            </p>
                        </div>
                    </div>


                </div>
            </div>

            <!-- Footer - STICKY -->
            <div
                class="flex-shrink-0 flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-white dark:bg-gray-900">
                <button type="button" disabled
                    class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-300 cursor-not-allowed">Previous</button>
                <button type="button" (click)="goPostStep(2)"
                    [disabled]="(postSelectedMedia.length === 0 && !selectedPostGradient) || hasPendingPostPreviews"
                    class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] disabled:opacity-40 disabled:cursor-not-allowed transition-colors">Next</button>
            </div>
        </ng-container>

        <!-- ════ STEP 2: Preview & Arrange ════ -->
        <ng-container *ngIf="postStep === 2">
            <div class="flex-1 overflow-y-auto">
                <div class="px-6 py-5 space-y-4">
                    <div class="flex items-center justify-between">
                        <div>
                            <h5 class="text-sm font-semibold text-gray-800">Preview &amp; Arrange</h5>
                            <p class="text-xs text-gray-400 mt-0.5">
                                <ng-container *ngIf="!isEditPostMode">Click a thumbnail to preview · Drag to reorder</ng-container>
                                <ng-container *ngIf="isEditPostMode">Existing media (kept) + any newly added files</ng-container>
                            </p>
                        </div>
                        <span class="text-xs font-medium text-gray-400 bg-gray-100 px-2.5 py-1 rounded-full">
                            {{ postSelectedMedia.length }} file{{ postSelectedMedia.length !== 1 ? 's' : '' }}
                        </span>
                    </div>
                    <!-- Big preview — unified list -->
                    <div class="rounded-2xl overflow-hidden w-full bg-black" style="height:300px;">
                        <ng-container *ngIf="postSelectedMedia[postActiveMediaIndex] as active">
                            <img *ngIf="active.type === 'image' && active.url" [src]="active.url"
                                class="w-full h-full object-cover transition-opacity duration-200" />
                            <video *ngIf="active.type === 'video' && active.url" [src]="active.url"
                                class="w-full h-full object-contain" controls></video>
                            <div *ngIf="!active.savedId && !active.isPreviewReady"
                                class="flex h-full w-full items-center justify-center bg-gray-950 px-6 text-center">
                                <div class="w-full max-w-xs">
                                    <p class="text-sm font-semibold text-white">Preparing preview</p>
                                    <p class="mt-1 text-xs text-gray-300">{{ active.file?.name }}</p>
                                    <div class="mt-4 h-2 overflow-hidden rounded-full bg-white/20">
                                        <div class="h-full rounded-full bg-[#D31148] transition-all duration-200"
                                            [style.width.%]="active.previewProgress"></div>
                                    </div>
                                    <p class="mt-2 text-xs font-medium text-rose-200">{{ active.previewProgress }}%</p>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <!-- Single unified draggable thumbnail strip -->
                    <div *ngIf="postSelectedMedia.length > 0" class="flex gap-2 flex-wrap" cdkDropList cdkDropListOrientation="horizontal"
                        (cdkDropListDropped)="onPostMediaDrop($event)">
                        <div *ngFor="let m of postSelectedMedia; let i = index" cdkDrag
                            (click)="setPostActiveMedia(i)"
                            class="relative w-20 h-16 rounded-xl overflow-hidden border-2 cursor-grab active:cursor-grabbing transition-all duration-150 select-none group"
                            [class.border-[#D31148]]="i === postActiveMediaIndex"
                            [class.border-gray-200]="i !== postActiveMediaIndex"
                            [class.opacity-60]="i !== postActiveMediaIndex">
                            <img *ngIf="m.type === 'image' && m.url" [src]="m.url"
                                class="w-full h-full object-cover pointer-events-none" />
                            <video *ngIf="m.type === 'video' && m.url" [src]="m.url"
                                class="w-full h-full object-cover pointer-events-none" muted playsinline></video>
                            <div *ngIf="!m.url" class="absolute inset-0 bg-gray-100 animate-pulse"></div>
                            <span *ngIf="m.type === 'video'"
                                class="absolute bottom-0.5 left-0.5 bg-black/70 text-white text-[8px] font-bold px-1 py-0.5 rounded leading-none">VIDEO</span>
                            <span *ngIf="m.savedId"
                                class="absolute top-0.5 left-0.5 bg-[#D31148]/80 text-white text-[8px] font-bold px-1 py-0.5 rounded leading-none">Saved</span>
                            <span *ngIf="!m.savedId"
                                class="absolute top-0.5 left-0.5 bg-blue-500/90 text-white text-[8px] font-bold px-1 py-0.5 rounded leading-none">New</span>
                            <!-- Always visible — no hover on touch devices. -->
                            <button type="button" (click)="$event.stopPropagation(); removePostMedia(i)"
                                aria-label="Remove media"
                                class="absolute top-0.5 right-0.5 w-5 h-5 bg-white/90 rounded-full flex items-center justify-center shadow transition-colors hover:bg-white">
                                <svg width="6" height="6" viewBox="0 0 6 6">
                                    <path d="M1 1L5 5M5 1L1 5" stroke="#374151" stroke-width="1.2" stroke-linecap="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer - STICKY -->
            <div
                class="flex-shrink-0 flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-white dark:bg-gray-900">
                <button type="button" (click)="goPostStep(1)"
                    class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Previous</button>
                <button type="button" (click)="goPostStep(3)"
                    class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] transition-colors">Next</button>
            </div>
        </ng-container>

        <!-- ════ STEP 3: Caption & Details ════ -->
        <ng-container *ngIf="postStep === 3">
            <div class="flex-1 overflow-y-auto">
                <div class="space-y-0">

                    <!-- Unified media strip — saved + new in arranged order -->
                    <div *ngIf="postSelectedMedia.length > 0" class="flex overflow-x-auto"
                        style="scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; gap: 10px; margin: 0 24px 4px 24px; scrollbar-width: none;">
                        <div *ngFor="let m of postSelectedMedia"
                            class="relative flex-shrink-0 overflow-hidden bg-gray-100"
                            style="width: 175px; height: 175px; border-radius: 16px; scroll-snap-align: start; box-shadow: 0 2px 8px rgba(0,0,0,0.10);">
                            <img *ngIf="m.type === 'image' && m.url" [src]="m.url" class="w-full h-full object-cover"
                                style="border-radius: 16px;" />
                            <video *ngIf="m.type === 'video' && m.url" [src]="m.url" class="w-full h-full object-cover"
                                style="border-radius: 16px;" muted playsinline (mouseenter)="$any($event.target).play()"
                                (mouseleave)="$any($event.target).pause()"></video>
                            <div *ngIf="!m.url" class="absolute inset-0 bg-gray-100 animate-pulse"></div>
                            <span *ngIf="m.type === 'video'"
                                class="absolute bottom-2 left-2 bg-black/70 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-md">VIDEO</span>
                        </div>
                    </div>

                                        <!-- Pattern preview with editable caption overlay -->
                    <div *ngIf="selectedPostGradient && postSelectedMedia.length === 0"
                        class="relative w-full overflow-visible"
                        style="height: 260px; margin: 0 24px 4px 24px; width: auto;"
                        [ngClass]="getSelectedPattern()?.patternClass"
                        [style.background-color]="getSelectedPattern()?.bg" [style.color]="getSelectedPattern()?.color">
                        <div #patternMentionDir="appMentionInput" #patternCaptionEl appMentionInput [submitOnEnter]="false" contenteditable="true" role="textbox"
                            aria-multiline="true"
                            data-pattern-caption
                            [attr.data-placeholder]="'What are you up to? Type @ to mention someone'"
                            class="absolute inset-0 w-full h-full bg-transparent border-none outline-none px-5 pt-5 text-xl font-bold leading-snug mention-editable mention-editable--full"
                            [style.color]="getSelectedPattern()?.textColor"
                            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); --mention-placeholder: rgba(255,255,255,0.75);"
                            (mentionSearch)="onCaptionMentionSearch($event)"
                            (mentionDropdown)="onCaptionMentionDropdown($event)" (valueChange)="postCaption = $event">
                        </div>
                        <app-mention-dropdown [isOpen]="isCaptionMentionOpen" [users]="captionMentionUsers"
                            position="below"
                            (selected)="postCaption = patternMentionDir.insertMention($event, postCaption); onCaptionMentionSelected($event)">
                        </app-mention-dropdown>

                        <!-- Emoji -->
                        <div data-caption-emoji-section>
                            <button #patternEmojiBtn type="button"
                                (click)="toggleCaptionEmojiPicker(patternEmojiBtn); $event.stopPropagation()"
                                title="Emoji"
                                class="absolute top-2 right-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black/25 text-white hover:bg-black/40 transition-colors">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                    <line x1="9" y1="9" x2="9.01" y2="9" />
                                    <line x1="15" y1="9" x2="15.01" y2="9" />
                                </svg>
                            </button>
                            <app-emoji-picker [isOpen]="showCaptionEmojiPicker" [anchorTop]="captionEmojiDDPos.top"
                                [anchorLeft]="captionEmojiDDPos.left" [boundsElement]="postModal.contentElement"
                                (pick)="pickCaptionEmoji($event, patternCaptionEl)">
                            </app-emoji-picker>
                        </div>
                    </div>

                    <!-- Form fields -->
                    <div class="px-6 pt-5 pb-2 space-y-4">

                        <!-- Caption with @mention support — media posts only -->
                        <div *ngIf="!selectedPostGradient" class="relative">
                            <div class="flex items-center justify-between mb-1.5">
                                <label class="text-sm font-semibold text-gray-700 flex items-center gap-1">
                                    Write something... <span class="text-[#D31148]">*</span>
                                </label>
                                <div class="dd-host relative flex-shrink-0" data-caption-emoji-section>
                                    <button #mediaEmojiBtn type="button"
                                        (click)="toggleCaptionEmojiPicker(mediaEmojiBtn); $event.stopPropagation()"
                                        [class.text-[#D31148]]="showCaptionEmojiPicker" title="Emoji"
                                        class="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 transition-colors">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                            <line x1="9" y1="9" x2="9.01" y2="9" />
                                            <line x1="15" y1="9" x2="15.01" y2="9" />
                                        </svg>
                                    </button>
                                    <app-emoji-picker [isOpen]="showCaptionEmojiPicker" [anchorTop]="captionEmojiDDPos.top"
                                        [anchorLeft]="captionEmojiDDPos.left" [boundsElement]="postModal.contentElement"
                                        (pick)="pickCaptionEmoji($event, captionEl)">
                                    </app-emoji-picker>
                                </div>
                            </div>
                            <!-- The appMentionInput directive listens for @ and fires mentionSearch -->
                            <div #captionMentionDir="appMentionInput" #captionEl appMentionInput [submitOnEnter]="false" contenteditable="true"
                                role="textbox" aria-multiline="true"
                                data-media-caption
                                [attr.data-placeholder]="'Add a caption… type @ to mention someone'"
                                (mentionSearch)="onCaptionMentionSearch($event)"
                                (mentionDropdown)="onCaptionMentionDropdown($event)"
                                (valueChange)="postCaption = $event"
                                class="mention-editable mention-editable--lines-4 w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700 outline-none focus:border-[#D31148] transition-colors">
                            </div>
                            <!-- Mention dropdown appears above the textarea -->
                            <app-mention-dropdown [isOpen]="isCaptionMentionOpen" [users]="captionMentionUsers"
                                position="below"
                                (selected)="postCaption = captionMentionDir.insertMention($event, postCaption); onCaptionMentionSelected($event)">
                            </app-mention-dropdown>

                            <!-- Open Graph preview of the first link pasted/typed in the caption.
                                 Media posts only — background posts never show a link preview. -->
                            <app-link-preview variant="composer" [text]="postCaption"
                                [enabled]="postSelectedMedia.length > 0">
                            </app-link-preview>
                        </div>

                        <!-- ── Tag People (search anyone) — edit mode only on step 3 ── -->
                        <div *ngIf="isEditPostMode" data-tag-section>
                            <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                (click)="togglePostTagPeople()">
                                <div class="flex items-center gap-3">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        class="text-gray-500 flex-shrink-0">
                                        <path
                                            d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                                            fill="currentColor" opacity="0.7" />
                                    </svg>
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-medium text-gray-700">Tag people</span>
                                        <span *ngIf="postTaggedPeople.length > 0"
                                            class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                            postTaggedPeople.length }}</span>
                                    </div>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    class="text-gray-400 flex-shrink-0 transition-transform"
                                    [class.rotate-90]="showPostTagPeople">
                                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>

                            <div *ngIf="showPostTagPeople" class="mt-2 space-y-2">
                                <!-- Tagged pills -->
                                <div *ngIf="postTaggedPeople.length > 0" class="flex flex-wrap gap-2 px-1">
                                    <span *ngFor="let u of postTaggedPeople"
                                        class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 pl-1 pr-2 py-1 text-xs font-medium text-gray-700">
                                        <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                            class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                        <span *ngIf="!u.profileImage?.urlSmall"
                                            class="w-5 h-5 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] text-[9px] font-bold flex-shrink-0">{{
                                            u.displayName.charAt(0) }}</span>
                                        @{{ u.userName }}
                                        <button type="button" (click)="removePostTag(u._id)"
                                            class="text-gray-400 hover:text-gray-600 leading-none font-bold">×</button>
                                    </span>
                                </div>
                                <!-- Search input -->
                                <div class="relative px-1">
                                    <input type="text" [(ngModel)]="tagSearchInput" name="tagSearchInput"
                                        placeholder="Search anyone by name or username…"
                                        (input)="onTagSearchInput($any($event.target).value)"
                                        (focus)="tagInputFocused = true" (blur)="onTagInputBlur()"
                                        class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                        <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                            stroke-linecap="round" />
                                    </svg>
                                </div>
                                <!-- Search results dropdown -->
                                <div *ngIf="tagInputFocused && tagSearchResults.length > 0"
                                    class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                    <button *ngFor="let u of tagSearchResults" type="button" (mousedown)="addPostTag(u)"
                                        class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                        <div class="relative flex-shrink-0">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                            <div *ngIf="!u.profileImage?.urlSmall"
                                                class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="text-sm font-semibold text-gray-800 truncate">{{ u.displayName
                                                }}
                                            </div>
                                            <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                        </div>
                                        <span *ngIf="u.isFriend"
                                            class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                    </button>
                                </div>
                                <!-- Empty state -->
                                <p *ngIf="tagInputFocused && tagSearchInput.length > 0 && tagSearchResults.length === 0"
                                    class="text-xs text-gray-400 px-1 text-center py-2">No users found for "{{
                                    tagSearchInput }}"</p>
                            </div>
                        </div>

                        <!-- ── Invite Collaborators (following only) — edit mode only on step 3 ── -->
                        <div *ngIf="isEditPostMode" data-collab-section>
                            <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                (click)="togglePostCollaborators()">
                                <div class="flex items-center gap-3">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        class="text-gray-500 flex-shrink-0">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="1.6" stroke-linecap="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.6" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                            stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                    </svg>
                                    <div class="flex items-center gap-2">
                                        <span class="text-sm font-medium text-gray-700">
                                            {{ isEditPostMode ? 'Manage Collaborators' : 'Invite Collaborators' }}
                                        </span>
                                        <span *ngIf="postCollaborators.length > 0"
                                            class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                            postCollaborators.length }}</span>
                                    </div>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    class="text-gray-400 flex-shrink-0 transition-transform"
                                    [class.rotate-90]="showPostCollaborators">
                                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>

                            <div *ngIf="showPostCollaborators" class="mt-2 space-y-2">
                                <!-- Helper text -->
                                <p *ngIf="!isEditPostMode" class="text-xs text-gray-400 px-1">
                                    Invite friends to collaborate on this post. They’ll receive a notification to accept or decline.
                                </p>
                                <p *ngIf="isEditPostMode" class="text-xs text-gray-400 px-1">
                                    Tap × to remove a collaborator. Add new ones by searching below.
                                </p>

                                <!-- Collaborator pills with status badge -->
                                <div *ngIf="postCollaborators.length > 0" class="flex flex-wrap gap-2 px-1">
                                    <span *ngFor="let u of postCollaborators"
                                        class="inline-flex items-center gap-1.5 rounded-full border pl-1 pr-2 py-1 text-xs font-medium"
                                        [class.bg-emerald-50]="u.collabStatus === 'ACCEPTED'"
                                        [class.border-emerald-200]="u.collabStatus === 'ACCEPTED'"
                                        [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                        [class.bg-amber-50]="u.collabStatus === 'PENDING'"
                                        [class.border-amber-200]="u.collabStatus === 'PENDING'"
                                        [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                        [class.bg-rose-50]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                        [class.border-rose-200]="!u.collabStatus || u.collabStatus === 'DECLINED'"
                                        [class.text-[#D31148]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                        <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                            class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                        <span *ngIf="!u.profileImage?.urlSmall"
                                            class="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold flex-shrink-0"
                                            [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                            [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                            [class.bg-[#FFD4E0]]="!u.collabStatus || u.collabStatus === 'DECLINED'">
                                            {{ u.displayName.charAt(0) }}
                                        </span>
                                        <span>@{{ u.userName }}</span>
                                        <!-- Status badge (edit mode only) -->
                                        <span *ngIf="isEditPostMode && u.collabStatus"
                                            class="text-[9px] font-bold px-1 py-0.5 rounded-full leading-none"
                                            [class.bg-emerald-100]="u.collabStatus === 'ACCEPTED'"
                                            [class.text-emerald-700]="u.collabStatus === 'ACCEPTED'"
                                            [class.bg-amber-100]="u.collabStatus === 'PENDING'"
                                            [class.text-amber-700]="u.collabStatus === 'PENDING'"
                                            [class.bg-rose-100]="u.collabStatus === 'DECLINED'"
                                            [class.text-rose-600]="u.collabStatus === 'DECLINED'">
                                            {{ u.collabStatus === 'ACCEPTED' ? '✓ Accepted' : u.collabStatus === 'PENDING' ? '⏳ Pending' : '✗ Declined' }}
                                        </span>
                                        <button type="button" (click)="removeCollaborator(u._id)"
                                            class="leading-none font-bold ml-0.5 hover:opacity-70"
                                            [class.text-emerald-500]="u.collabStatus === 'ACCEPTED'"
                                            [class.text-amber-500]="u.collabStatus === 'PENDING'"
                                            [class.text-rose-400]="!u.collabStatus || u.collabStatus === 'DECLINED'">×</button>
                                    </span>
                                </div>

                                <!-- Search input -->
                                <div class="relative px-1">
                                    <input type="text" [(ngModel)]="collabSearchInput" name="collabSearchInput"
                                        placeholder="Search your friends…"
                                        (input)="onCollabSearchInput($any($event.target).value)"
                                        (focus)="collabInputFocused = true" (blur)="onCollabInputBlur()"
                                        class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                        <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                            stroke-linecap="round" />
                                    </svg>
                                </div>
                                <!-- Collaborator results -->
                                <div *ngIf="collabInputFocused && collabSearchResults.length > 0"
                                    class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                    <button *ngFor="let u of collabSearchResults" type="button"
                                        (mousedown)="addCollaborator(u)"
                                        class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                        <div class="relative flex-shrink-0">
                                            <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                                class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                            <div *ngIf="!u.profileImage?.urlSmall"
                                                class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                                {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="text-sm font-semibold text-gray-800 truncate">{{ u.displayName }}</div>
                                            <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                        </div>
                                        <span *ngIf="u.isFriend"
                                            class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                    </button>
                                </div>
                                <!-- No results -->
                                <p *ngIf="collabInputFocused && collabSearchInput.length > 0 && collabSearchResults.length === 0"
                                    class="text-xs text-gray-400 px-1 text-center py-2">No results. You can only invite
                                    people you follow.</p>
                                <!-- Empty initial state -->
                                <p *ngIf="collabInputFocused && collabSearchInput.length === 0 && collabSearchResults.length === 0"
                                    class="text-xs text-gray-400 px-1 text-center py-2">You don't follow anyone yet, or
                                    everyone is already invited.</p>
                            </div>
                        </div>

                        <!-- Hashtags — edit mode only on step 3 (create mode: moved to step 4) -->
                        <div *ngIf="isEditPostMode">
                            <div *ngIf="postHashtags.length > 0" class="flex flex-wrap gap-2 mb-2">
                                <span *ngFor="let tag of postHashtags"
                                    class="inline-flex items-center gap-1 rounded-full bg-[#D31148] px-3 py-1 text-xs font-semibold text-white">
                                    #{{ tag }}
                                    <button type="button" (click)="removePostHashtag(tag)"
                                        class="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none text-[10px] hover:bg-white/90">×</button>
                                </span>
                            </div>
                            <div class="relative">
                                <input type="text" appHashtagInput #postHashDir="appHashtagInput"
                                    [(ngModel)]="postHashtagInput" name="postHashtagInput"
                                    (hashtagSearch)="onPostHashSearch($event)"
                                    (hashtagDropdown)="postHashDropOpen = $event"
                                    (keydown.enter)="addPostHashtag($event)" (keydown.space)="addPostHashtag($event)" (separatorTyped)="addPostHashtag($event)"
                                    (keydown.comma)="addPostHashtag($event)" placeholder="Add hashtags (e.g. london)"
                                    class="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                <app-hashtag-dropdown
                                    [isOpen]="postHashDropOpen"
                                    [tags]="postHashSuggestions"
                                    position="above"
                                    (selected)="onPostHashSelected($event)">
                                </app-hashtag-dropdown>
                            </div>
                            <p class="text-xs text-gray-400 mt-1">Press Enter, Space - or pick a suggestion</p>
                        </div>

                        <!-- Audience — edit mode only on step 3 -->
                        <div *ngIf="isEditPostMode">
                            <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                (click)="togglePostAudience()">
                                <div class="flex items-center gap-3">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        class="text-gray-500 flex-shrink-0">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6" />
                                        <path
                                            d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z"
                                            stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                    </svg>
                                    <div>
                                        <span class="text-sm font-medium text-gray-700">Audience</span>
                                        <ng-container *ngIf="postAudience">
                                            <ng-container *ngFor="let opt of postAudienceOptions">
                                                <span *ngIf="opt.value === postAudience"
                                                    class="inline-flex items-center gap-1 text-xs font-semibold text-[#D31148] bg-rose-50 border border-rose-200 rounded-full px-2 py-0.5 ml-3">
                                                    {{ opt.icon }} {{ opt.label }}
                                                </span>
                                            </ng-container>
                                        </ng-container>
                                        <span *ngIf="!postAudience" class="text-xs text-gray-400 ml-3">Not set</span>
                                    </div>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    class="text-gray-400 flex-shrink-0 transition-transform"
                                    [class.rotate-90]="showPostAudience">
                                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div *ngIf="showPostAudience" class="mt-2 grid grid-cols-1 gap-1.5 px-1">
                                <button *ngFor="let opt of postAudienceOptions" type="button"
                                    (click)="selectPostAudience(opt.value)"
                                    class="flex items-center gap-3 px-4 py-2.5 rounded-xl border transition-colors text-left"
                                    [class.border-[#D31148]]="postAudience === opt.value"
                                    [class.bg-rose-50]="postAudience === opt.value"
                                    [class.border-gray-200]="postAudience !== opt.value">
                                    <span class="flex-shrink-0 text-lg">{{ opt.icon }}</span>
                                    <div class="flex-1">
                                        <p class="text-sm font-medium text-gray-700">{{ opt.label }}</p>
                                        <p class="text-xs text-gray-400">{{ opt.desc }}</p>
                                    </div>
                                    <svg *ngIf="postAudience === opt.value" class="ml-auto flex-shrink-0 text-[#D31148]"
                                        width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M3 8l3.5 3.5L13 4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <!-- Location — edit mode only on step 3 (create mode: moved to step 4) -->
                        <div *ngIf="isEditPostMode">
                            <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                                (click)="togglePostLocation()">
                                <div class="flex items-center gap-3">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        class="text-gray-500 flex-shrink-0">
                                        <path
                                            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                                            stroke="currentColor" stroke-width="1.6" />
                                        <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6" />
                                    </svg>
                                    <div>
                                        <span class="text-sm font-medium text-gray-700">Add Location</span>
                                        <span *ngIf="postLocation" class="ml-2 text-xs text-[#D31148] font-semibold">{{
                                            postLocation }}</span>
                                    </div>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    class="text-gray-400 flex-shrink-0 transition-transform"
                                    [class.rotate-90]="showPostLocation">
                                    <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div *ngIf="showPostLocation" class="mt-2 px-1">
                                <div class="relative">
                                    <input #postLocationInput type="text" [(ngModel)]="postLocation" name="postLocation"
                                        placeholder="Search or enter a location..."
                                        class="w-full rounded-xl border border-gray-200 pl-10 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <path
                                            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                                            stroke="currentColor" stroke-width="1.6" />
                                        <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6" />
                                    </svg>
                                </div>
                                <div *ngIf="postLocation.length === 0" class="flex flex-wrap gap-2 mt-2">
                                    <button *ngFor="let s of postLocationSuggestions" type="button"
                                        (click)="postLocation = s"
                                        class="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs text-gray-600 hover:border-[#D31148] hover:text-[#D31148] transition-colors">
                                        📍 {{ s }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Feedback -->
                        <p *ngIf="postSaveError" class="text-sm text-red-500">{{ postSaveError }}</p>
                        <p *ngIf="postSaveSuccess" class="text-sm text-green-600">{{ postSaveSuccess }}</p>

                    </div><!-- /form fields -->
                </div>
            </div>

            <!-- Footer - STICKY -->
            <div class="px-6 py-4 border-t border-gray-100 bg-white dark:bg-gray-900">
                <!-- Upload progress (edit mode) -->
                <div *ngIf="isPostSaving && isEditPostMode" class="rounded-xl bg-rose-50 px-3 py-2">
                    <div class="flex items-center justify-between gap-3">
                        <p class="text-xs font-medium text-rose-900">Saving your post</p>
                        <span class="text-xs font-semibold text-[#D31148]">{{ postUploadProgress }}%</span>
                    </div>
                    <div class="mt-2 h-1.5 overflow-hidden rounded-full bg-rose-100">
                        <div class="h-full rounded-full bg-[#D31148] transition-all duration-200"
                            [style.width.%]="postUploadProgress"></div>
                    </div>
                </div>
                <div class="flex-shrink-0 flex items-center justify-end gap-3 mt-3">
                    <!-- Create mode: Previous -->
                    <button *ngIf="!isEditPostMode" type="button" (click)="goPostStep(2)" [disabled]="isPostSaving"
                        class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Previous</button>
                    <!-- Edit mode: Cancel -->
                    <button *ngIf="isEditPostMode" type="button" (click)="closePostModal()" [disabled]="isPostSaving"
                        class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                    <!-- Create mode: Next → step 4 -->
                    <button *ngIf="!isEditPostMode" type="button" (click)="goPostStep(4)"
                        [disabled]="isPostSaving || hasPendingPostPreviews"
                        class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] disabled:opacity-40 disabled:cursor-not-allowed transition-colors">Next</button>
                    <!-- Edit mode: Save Changes -->
                    <button *ngIf="isEditPostMode" type="button" (click)="saveEditPost()"
                        [disabled]="isPostSaving || hasPendingPostPreviews"
                        class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        {{ isPostSaving ? 'Saving...' : 'Save Changes' }}
                    </button>
                </div>
            </div>
        </ng-container>

        <!-- ════ STEP 4 (create only): Tag People · Collaborators · Audience ════ -->
        <ng-container *ngIf="postStep === 4">
            <div class="flex-1 overflow-y-auto">
                <div class="px-6 py-5 space-y-4">

                    <!-- ── Tag People ── -->
                    <div data-tag-section>
                        <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                            (click)="togglePostTagPeople()">
                            <div class="flex items-center gap-3">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    class="text-gray-500 flex-shrink-0">
                                    <path
                                        d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                                        fill="currentColor" opacity="0.7" />
                                </svg>
                                <div class="flex items-center gap-2">
                                    <span class="text-sm font-medium text-gray-700">Tag people</span>
                                    <span *ngIf="postTaggedPeople.length > 0"
                                        class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                        postTaggedPeople.length }}</span>
                                </div>
                            </div>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                class="text-gray-400 flex-shrink-0 transition-transform"
                                [class.rotate-90]="showPostTagPeople">
                                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <div *ngIf="showPostTagPeople" class="mt-2 space-y-2">
                            <div *ngIf="postTaggedPeople.length > 0" class="flex flex-wrap gap-2 px-1">
                                <span *ngFor="let u of postTaggedPeople"
                                    class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 pl-1 pr-2 py-1 text-xs font-medium text-gray-700">
                                    <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                        class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                    <span *ngIf="!u.profileImage?.urlSmall"
                                        class="w-5 h-5 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] text-[9px] font-bold flex-shrink-0">{{
                                        u.displayName.charAt(0) }}</span>
                                    @{{ u.userName }}
                                    <button type="button" (click)="removePostTag(u._id)"
                                        class="text-gray-400 hover:text-gray-600 leading-none font-bold">×</button>
                                </span>
                            </div>
                            <div class="relative px-1">
                                <input type="text" [(ngModel)]="tagSearchInput" name="tagSearchInput"
                                    placeholder="Search anyone by name or username…"
                                    (input)="onTagSearchInput($any($event.target).value)"
                                    (focus)="tagInputFocused = true" (blur)="onTagInputBlur()"
                                    class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                    <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                        stroke-linecap="round" />
                                </svg>
                            </div>
                            <div *ngIf="tagInputFocused && tagSearchResults.length > 0"
                                class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                <button *ngFor="let u of tagSearchResults" type="button" (mousedown)="addPostTag(u)"
                                    class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                    <div class="relative flex-shrink-0">
                                        <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                            class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                        <div *ngIf="!u.profileImage?.urlSmall"
                                            class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                            {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                    </div>
                                    <div class="flex-1 min-w-0">
                                        <div class="text-sm font-semibold text-gray-800 truncate">{{ u.displayName }}</div>
                                        <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                    </div>
                                    <span *ngIf="u.isFriend"
                                        class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                </button>
                            </div>
                            <p *ngIf="tagInputFocused && tagSearchInput.length > 0 && tagSearchResults.length === 0"
                                class="text-xs text-gray-400 px-1 text-center py-2">No users found for "{{
                                tagSearchInput }}"</p>
                        </div>
                    </div>

                    <!-- ── Invite Collaborators ── -->
                    <div data-collab-section>
                        <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                            (click)="togglePostCollaborators()">
                            <div class="flex items-center gap-3">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    class="text-gray-500 flex-shrink-0">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                        stroke-width="1.6" stroke-linecap="round" />
                                    <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.6" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                        stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                </svg>
                                <div class="flex items-center gap-2">
                                    <span class="text-sm font-medium text-gray-700">Invite Collaborators</span>
                                    <span *ngIf="postCollaborators.length > 0"
                                        class="text-xs font-semibold text-[#D31148] bg-rose-50 px-2 py-0.5 rounded-full">{{
                                        postCollaborators.length }}</span>
                                </div>
                            </div>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                class="text-gray-400 flex-shrink-0 transition-transform"
                                [class.rotate-90]="showPostCollaborators">
                                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>

                        <div *ngIf="showPostCollaborators" class="mt-2 space-y-2">
                            <p class="text-xs text-gray-400 px-1">
                                Invite friends to collaborate on this post. They'll receive a notification to accept or decline.
                            </p>
                            <div *ngIf="postCollaborators.length > 0" class="flex flex-wrap gap-2 px-1">
                                <span *ngFor="let u of postCollaborators"
                                    class="inline-flex items-center gap-1.5 rounded-full border pl-1 pr-2 py-1 text-xs font-medium bg-rose-50 border-rose-200 text-[#D31148]">
                                    <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                        class="w-5 h-5 rounded-full object-cover flex-shrink-0" />
                                    <span *ngIf="!u.profileImage?.urlSmall"
                                        class="w-5 h-5 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[9px] font-bold flex-shrink-0">
                                        {{ u.displayName.charAt(0) }}
                                    </span>
                                    <span>@{{ u.userName }}</span>
                                    <button type="button" (click)="removeCollaborator(u._id)"
                                        class="leading-none font-bold ml-0.5 text-rose-400 hover:opacity-70">×</button>
                                </span>
                            </div>
                            <div class="relative px-1">
                                <input type="text" [(ngModel)]="collabSearchInput" name="collabSearchInput"
                                    placeholder="Search your friends…"
                                    (input)="onCollabSearchInput($any($event.target).value)"
                                    (focus)="collabInputFocused = true" (blur)="onCollabInputBlur()"
                                    class="w-full rounded-xl border border-gray-200 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8" />
                                    <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.8"
                                        stroke-linecap="round" />
                                </svg>
                            </div>
                            <div *ngIf="collabInputFocused && collabSearchResults.length > 0"
                                class="mx-1 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden">
                                <button *ngFor="let u of collabSearchResults" type="button"
                                    (mousedown)="addCollaborator(u)"
                                    class="flex w-full items-center gap-3 px-3 py-2.5 hover:bg-[#fff5f7] transition-colors text-left">
                                    <div class="relative flex-shrink-0">
                                        <img *ngIf="u.profileImage?.urlSmall" [src]="u.profileImage!.urlSmall"
                                            class="w-9 h-9 rounded-full object-cover border border-gray-100" />
                                        <div *ngIf="!u.profileImage?.urlSmall"
                                            class="w-9 h-9 rounded-full bg-[#FFD4E0] flex items-center justify-center text-[#D31148] font-bold text-sm flex-shrink-0">
                                            {{ u.displayName.charAt(0).toUpperCase() }}</div>
                                    </div>
                                    <div class="flex-1 min-w-0">
                                        <div class="text-sm font-semibold text-gray-800 truncate">{{ u.displayName }}</div>
                                        <div class="text-xs text-gray-400 truncate">@{{ u.userName }}</div>
                                    </div>
                                    <span *ngIf="u.isFriend"
                                        class="flex-shrink-0 text-[10px] font-semibold text-[#10b981] bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5">Friend</span>
                                </button>
                            </div>
                            <p *ngIf="collabInputFocused && collabSearchInput.length > 0 && collabSearchResults.length === 0"
                                class="text-xs text-gray-400 px-1 text-center py-2">No results. You can only invite people you follow.</p>
                            <p *ngIf="collabInputFocused && collabSearchInput.length === 0 && collabSearchResults.length === 0"
                                class="text-xs text-gray-400 px-1 text-center py-2">You don't follow anyone yet, or everyone is already invited.</p>
                        </div>
                    </div>

                    <!-- ── Hashtags ── -->
                    <div>
                        <div *ngIf="postHashtags.length > 0" class="flex flex-wrap gap-2 mb-2">
                            <span *ngFor="let tag of postHashtags"
                                class="inline-flex items-center gap-1 rounded-full bg-[#D31148] px-3 py-1 text-xs font-semibold text-white">
                                #{{ tag }}
                                <button type="button" (click)="removePostHashtag(tag)"
                                    class="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full bg-white text-[#D31148] font-bold leading-none text-[10px] hover:bg-white/90">×</button>
                            </span>
                        </div>
                        <div class="relative">
                            <input type="text" appHashtagInput #postHashDir="appHashtagInput"
                                [(ngModel)]="postHashtagInput" name="postHashtagInput"
                                (hashtagSearch)="onPostHashSearch($event)"
                                (hashtagDropdown)="postHashDropOpen = $event"
                                (keydown.enter)="addPostHashtag($event)" (keydown.space)="addPostHashtag($event)" (separatorTyped)="addPostHashtag($event)"
                                (keydown.comma)="addPostHashtag($event)" placeholder="Add hashtags (e.g. london)"
                                class="w-full rounded-xl border border-gray-200 px-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                            <app-hashtag-dropdown
                                [isOpen]="postHashDropOpen"
                                [tags]="postHashSuggestions"
                                position="above"
                                (selected)="onPostHashSelected($event)">
                            </app-hashtag-dropdown>
                        </div>
                        <p class="text-xs text-gray-400 mt-1">Press Enter, Space - or pick a suggestion</p>
                    </div>

                    <!-- ── Audience ── -->
                    <div>
                        <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                            (click)="togglePostAudience()">
                            <div class="flex items-center gap-3">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    class="text-gray-500 flex-shrink-0">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6" />
                                    <path
                                        d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z"
                                        stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                                </svg>
                                <div>
                                    <span class="text-sm font-medium text-gray-700">Audience</span>
                                    <ng-container *ngIf="postAudience">
                                        <ng-container *ngFor="let opt of postAudienceOptions">
                                            <span *ngIf="opt.value === postAudience"
                                                class="inline-flex items-center gap-1 text-xs font-semibold text-[#D31148] bg-rose-50 border border-rose-200 rounded-full px-2 py-0.5 ml-3">
                                                {{ opt.icon }} {{ opt.label }}
                                            </span>
                                        </ng-container>
                                    </ng-container>
                                    <span *ngIf="!postAudience" class="text-xs text-gray-400 ml-3">Not set</span>
                                </div>
                            </div>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                class="text-gray-400 flex-shrink-0 transition-transform"
                                [class.rotate-90]="showPostAudience">
                                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div *ngIf="showPostAudience" class="mt-2 grid grid-cols-1 gap-1.5 px-1">
                            <button *ngFor="let opt of postAudienceOptions" type="button"
                                (click)="selectPostAudience(opt.value)"
                                class="flex items-center gap-3 px-4 py-2.5 rounded-xl border transition-colors text-left"
                                [class.border-[#D31148]]="postAudience === opt.value"
                                [class.bg-rose-50]="postAudience === opt.value"
                                [class.border-gray-200]="postAudience !== opt.value">
                                <span class="flex-shrink-0 text-lg">{{ opt.icon }}</span>
                                <div class="flex-1">
                                    <p class="text-sm font-medium text-gray-700">{{ opt.label }}</p>
                                    <p class="text-xs text-gray-400">{{ opt.desc }}</p>
                                </div>
                                <svg *ngIf="postAudience === opt.value" class="ml-auto flex-shrink-0 text-[#D31148]"
                                    width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M3 8l3.5 3.5L13 4" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- ── Location ── -->
                    <div>
                        <div class="flex items-center justify-between py-3 border border-gray-200 rounded-xl cursor-pointer hover:bg-gray-50 px-4 transition-colors"
                            (click)="togglePostLocation()">
                            <div class="flex items-center gap-3">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                    class="text-gray-500 flex-shrink-0">
                                    <path
                                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                                        stroke="currentColor" stroke-width="1.6" />
                                    <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6" />
                                </svg>
                                <div>
                                    <span class="text-sm font-medium text-gray-700">Add Location</span>
                                    <span *ngIf="postLocation" class="ml-2 text-xs text-[#D31148] font-semibold">{{
                                        postLocation }}</span>
                                </div>
                            </div>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                class="text-gray-400 flex-shrink-0 transition-transform"
                                [class.rotate-90]="showPostLocation">
                                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div *ngIf="showPostLocation" class="mt-2 px-1">
                            <div class="relative">
                                <input #postLocationInput type="text" [(ngModel)]="postLocation" name="postLocation"
                                    placeholder="Search or enter a location..."
                                    class="w-full rounded-xl border border-gray-200 pl-10 pr-4 py-2.5 text-sm outline-none focus:border-[#D31148] transition-colors placeholder:text-gray-400" />
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <path
                                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                                        stroke="currentColor" stroke-width="1.6" />
                                    <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6" />
                                </svg>
                            </div>
                            <div *ngIf="postLocation.length === 0" class="flex flex-wrap gap-2 mt-2">
                                <button *ngFor="let s of postLocationSuggestions" type="button"
                                    (click)="postLocation = s"
                                    class="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs text-gray-600 hover:border-[#D31148] hover:text-[#D31148] transition-colors">
                                    📍 {{ s }}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Footer - STICKY -->
            <div class="flex-shrink-0 flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100 bg-white dark:bg-gray-900">
                <button type="button" (click)="goPostStep(3)"
                    class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Previous</button>
                <button type="button" (click)="goPostStep(5)"
                    class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] transition-colors">Next</button>
            </div>
        </ng-container>

        <!-- ════ STEP 5 (create only): Consent & Publish ════ -->
        <ng-container *ngIf="postStep === 5">
            <div class="flex-1 overflow-y-auto">
                <div class="px-6 py-8 flex flex-col items-center justify-center gap-6 min-h-[300px]">

                    <!-- Icon -->
                    <div class="w-16 h-16 rounded-full bg-rose-50 flex items-center justify-center">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" class="text-[#D31148]">
                            <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Heading -->
                    <div class="text-center">
                        <h4 class="text-base font-bold text-gray-800">Almost there!</h4>
                        <p class="text-sm text-gray-500 mt-1">Please confirm before publishing.</p>
                    </div>

                    <!-- Consent checkbox -->
                    <label class="flex items-start gap-3 cursor-pointer group w-full max-w-sm">
                        <input type="checkbox" [(ngModel)]="postConsentChecked" name="postConsentChecked"
                            class="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-gray-300 text-[#D31148] accent-[#D31148] cursor-pointer" />
                        <span class="text-xs text-gray-600 leading-relaxed">
                            I certify that everyone in the picture / video consented to have it uploaded to Safeword, that everyone was 18 or older when it was taken and I have documentation to support this.
                        </span>
                    </label>

                    <!-- Error / Success -->
                    <p *ngIf="postSaveError" class="text-sm text-red-500 text-center">{{ postSaveError }}</p>
                    <p *ngIf="postSaveSuccess" class="text-sm text-green-600 text-center">{{ postSaveSuccess }}</p>

                </div>
            </div>

            <!-- Footer - STICKY -->
            <div class="px-6 py-4 border-t border-gray-100 bg-white dark:bg-gray-900">
                <div *ngIf="isPostSaving" class="rounded-xl bg-rose-50 px-3 py-2 mb-3">
                    <div class="flex items-center justify-between gap-3">
                        <p class="text-xs font-medium text-rose-900">Uploading your post</p>
                        <span class="text-xs font-semibold text-[#D31148]">{{ postUploadProgress }}%</span>
                    </div>
                    <div class="mt-2 h-1.5 overflow-hidden rounded-full bg-rose-100">
                        <div class="h-full rounded-full bg-[#D31148] transition-all duration-200"
                            [style.width.%]="postUploadProgress"></div>
                    </div>
                </div>
                <div class="flex-shrink-0 flex items-center justify-end gap-3">
                    <button type="button" (click)="goPostStep(4)" [disabled]="isPostSaving"
                        class="px-5 py-2 rounded-full text-sm font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">Previous</button>
                    <button type="button" (click)="publishPost()"
                        [disabled]="isPostSaving || hasPendingPostPreviews || !postConsentChecked"
                        class="px-5 py-2 rounded-full text-sm font-semibold text-white bg-[#D31148] hover:bg-[#b80e3d] disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        {{ isPostSaving ? 'Publishing...' : 'Publish' }}
                    </button>
                </div>
            </div>
        </ng-container>

    </div>
</app-modal>

<app-camera-capture [isOpen]="isCameraOpen" (photoTaken)="onPhotoCaptured($event)" (cancelled)="onCameraCancelled()">
</app-camera-capture>

<app-video-capture [isOpen]="isVideoCaptureOpen" (videoTaken)="onVideoCaptured($event)"
    (cancelled)="onVideoCaptureCancelled()">
</app-video-capture>

<style>
  /* ── Event date/time fields — match the height & border of app-input-field ──
     The Start/End date & time pickers use Angular Material's outlined
     mat-form-field, which is visually inconsistent with the rest of this form
     (56px tall, Material's default gray outline) — the other fields are all
     44px (h-11) with a #D0D5DD border. Material doesn't expose a per-field
     token for either of these in this theme, so they're overridden directly. */
  ::ng-deep .event-date-field .mat-mdc-text-field-wrapper {
    height: 44px;
  }
  ::ng-deep .event-date-field .mat-mdc-form-field-infix {
    min-height: 44px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  ::ng-deep .event-date-field .mdc-notched-outline__leading,
  ::ng-deep .event-date-field .mdc-notched-outline__notch,
  ::ng-deep .event-date-field .mdc-notched-outline__trailing {
    border-color: #D0D5DD !important;
  }
  ::ng-deep .event-date-field.mat-focused .mdc-notched-outline__leading,
  ::ng-deep .event-date-field.mat-focused .mdc-notched-outline__notch,
  ::ng-deep .event-date-field.mat-focused .mdc-notched-outline__trailing {
    border-color: #9cb9ff !important;
  }

  /* ── Event description editor content ────────────────────────────────────
     @kolkov/angular-editor ships with ViewEncapsulation.None and sets its own
     global `.angular-editor-wrapper p { margin-bottom: 0 }` rule, which wipes
     out paragraph spacing while typing even though the saved HTML renders
     correctly (with spacing) on the event listing/detail page via .event-prose.
     Override it here to match that same spacing so what you see while editing
     matches what viewers see afterward. */
  /* The very first line typed into a fresh contenteditable area is often left
     as a bare, unwrapped text node — only lines created afterwards via Enter
     get wrapped in a real <p>. Spacing via margin-bottom therefore depended on
     the EARLIER line owning a <p>, which the first line never has, making the
     gap after line 1 collapse to ~0 while every later gap got the full 1rem.
     Owning the spacing via margin-top on the LATER line instead fixes this,
     since every line after the first is always a real <p> — so every gap
     ends up the same regardless of how the first line happens to be wrapped. */
  ::ng-deep .event-editor .angular-editor-textarea p {
    margin-top: 1rem !important;
    margin-bottom: 0 !important;
  }

  ::ng-deep .event-editor .angular-editor-textarea p:first-child {
    margin-top: 0 !important;
  }

  /* Neither this editor nor @kolkov/angular-editor itself ever sets a
     line-height on the editable surface, so it falls back to the browser's
     bare "normal". The toolbar's Font Size dropdown still uses the legacy
     document.execCommand('fontSize') command, which wraps the selection in
     a bare <font size="7"> tag (~48px) with no line-height of its own — that
     tall inline run then collides with the line(s) above/below it. Giving
     the editable area a generous unitless line-height, and forcing any
     oversized <font> run onto its own line box, stops that overlap no
     matter how large the selected size is. */
  ::ng-deep .event-editor .angular-editor-textarea {
    line-height: 1.5;
  }

  ::ng-deep .event-editor .angular-editor-textarea font[size] {
    display: inline-block;
    line-height: 1.3;
  }

  ::ng-deep .event-editor .angular-editor-textarea h1 {
    font-size: 1.875rem;
    font-weight: 700;
    margin-bottom: .75rem;
  }

  ::ng-deep .event-editor .angular-editor-textarea h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: .75rem;
  }

  ::ng-deep .event-editor .angular-editor-textarea h3,
  ::ng-deep .event-editor .angular-editor-textarea h4 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: .5rem;
  }

  ::ng-deep .event-editor .angular-editor-textarea h5,
  ::ng-deep .event-editor .angular-editor-textarea h6 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: .5rem;
  }

  /* Native <ul>/<ol> markers are vertically centered within the list item's
     own line box. That's fine at normal text size, but this editor lets you
     set a huge font size (via the toolbar's legacy execCommand font sizing)
     on just the list item's text — which balloons the line box height while
     the marker itself stays small, so it ends up centered *inside* the tall
     glyph instead of aligned above it. Replacing native markers with an
     absolutely-positioned ::before pinned to the top of the (relatively
     positioned) <li> keeps the marker aligned to the top-left corner no
     matter how large the item's own content gets. */
  ::ng-deep .event-editor .angular-editor-textarea ul,
  ::ng-deep .event-editor .angular-editor-textarea ol {
    list-style: none;
    padding-left: 1.75em;
    margin-bottom: 1rem;
  }

  ::ng-deep .event-editor .angular-editor-textarea ol {
    counter-reset: event-ol-counter;
  }

  ::ng-deep .event-editor .angular-editor-textarea ul > li,
  ::ng-deep .event-editor .angular-editor-textarea ol > li {
    position: relative;
    margin-bottom: .50rem;
  }

  ::ng-deep .event-editor .angular-editor-textarea ol > li {
    counter-increment: event-ol-counter;
  }

  ::ng-deep .event-editor .angular-editor-textarea ul > li::before {
    content: '•';
    position: absolute;
    left: -1.25em;
    top: 0;
  }

  ::ng-deep .event-editor .angular-editor-textarea ol > li::before {
    content: counter(event-ol-counter) '.';
    position: absolute;
    left: -1.75em;
    top: 0;
  }

  /* Media caption box: let the user drag the bottom-right corner to grow/shrink
     it vertically, same as a native <textarea resize="vertical">. The shared
     .mention-editable--lines-4 rule in styles.css pins min-height/max-height to
     the same 6rem value, which leaves nothing for a resize handle to change.
     No max-height cap here — the modal body around this field (the step-3
     `.flex-1.overflow-y-auto` wrapper) already scrolls independently inside
     app-modal's fixed max-h-[...] shell, so an unbounded caption box just
     grows the scrollable area instead of the popup itself. */
  .mention-editable--lines-4 {
    height: 6rem;
    min-height: 6rem;
    max-height: none;
    resize: vertical;
  }
</style>